document.addEventListener('DOMContentLoaded', function () {
  const body = document.body;

  /* ---------- 70vh Scroll Toggle ---------- */
  let triggerHeight = window.innerHeight * 0.7;
  let ticking = false;

  function onScroll() {
    const scrolledPast = window.scrollY > triggerHeight;
    body.classList.toggle('scrolled-70vh', scrolledPast);
    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(onScroll);
      ticking = true;
    }
  });

  // Initial check + resize
  onScroll();
  window.addEventListener('resize', () => {
    triggerHeight = window.innerHeight * 0.7;
    onScroll();
  });

  /* ---------- Back To Top Button ---------- */
  const goTopBtn = document.querySelector('.back-to-top');
  if (goTopBtn) {
    const coords = 300;
    window.addEventListener('scroll', () => {
      goTopBtn.classList.toggle('hide', window.pageYOffset <= coords);
    });

    goTopBtn.addEventListener('click', e => {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
  
});

/* ---------- Header Background Check ---------- */
window.addEventListener('load', function () {
  const path = window.location.pathname;

  // 🚫 skip home page
  if (path === '/' || path === '/index') {
    return;
  }

  // 🚫 skip product pages (Shopify product pages always start with /products/)
  if (path.startsWith('/products/')) {
    return;
  }
  if (path.startsWith('/collections/straps')) {
    return;
  }
   if (path.startsWith('/blogs/museum-collection')) {
    return;
  }

  if (path.startsWith('/account/login')) {
    return;
  }

  const header = document.querySelector('sticky-header.header-wrapper.gradient');
  if (header) {
    const bgColor = getComputedStyle(header).backgroundColor;
    // check for pure white
    if (bgColor === 'rgb(255, 255, 255)') {
      document.body.classList.add('header-color-white');
    }
  }
});



